import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export interface BudgetScenario {
    id: number;
    name: string;
    correlationId: string;
}

export interface SubprojectBudgetScenarios {
    developmentSiteName: string;
    subprojectName: string;
    isEarlyPlanning: boolean;
    subprojectId: number;
    budgetScenarios: BudgetScenario[];
}

export const useGetProjectBudgetScenarios = (
    projectId?: string,
    options?: Omit<UseQueryOptions<SubprojectBudgetScenarios, Error, SubprojectBudgetScenarios>, 'queryKey' | 'queryFn'>,
) => useQuery<SubprojectBudgetScenarios, Error>({
    queryKey: ['projectBudgetScenarios', projectId],
    queryFn: async () => {
        if (!projectId) {
            return null;
        }
        const { data } = await axiosInstance.get(API_ENDPOINTS.PROJECT_BUDGET_SCENARIOS(projectId));
        return data;
    },
    enabled: Boolean(projectId),
    ...options,
});
